import { CSSObject } from '@chakra-ui/react';

export const BetSlipEmptyContainer: CSSObject = {
  justifyContent: 'flex-start',
  pt: '18',
  textAlign: 'center',
  mx: 'auto',
  w: 'full',
};
export const BetSlipEmptyHeading: CSSObject = {
  fontWeight: 'bold',
  fontSize: 'md',
  lineHeight: '1',
  color: 'beta.300',
  fontFamily: 'Roboto',
  textTransform: 'uppercase',
  w: '203px',
  my: '0',
};
export const BetSlipEmptySubheading: CSSObject = {
  fontWeight: 'normal',
  fontSize: 'sm',
  color: 'white',
  my: '1.5',
};
export const BoxHeadingIconContainer: CSSObject = {
  display: 'flex',
  flexDir: 'column-reverse',
  alignItems: 'center',
};
